import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  toRefs,
  watch,
  computed,
} from "vue";
import { ProjectService } from "../../views/data-board/project-board/project-board.service";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  props: {
    projectId: {
      type: String,
    },
    projectName: {
      type: String,
    },
    jump: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["changeProject", "update:projectName"],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const projectName = ref("");
    const projectList = ref();
    const projectId = ref();
    const fetching = ref(false);
    const pId = computed(() => {
      return props.projectId;
    });
    const pName = computed(() => {
      return props.projectName;
    });
    watch(
      () => projectId.value,
      (n, o) => {
        if (!n || n.length == 0) {
          projectName.value = "";
          initData("");
          emit("update:projectName", "");
          // emit("changeProject", projectId.value);
        }
      }
    );
    watch(
      () => pId.value,
      (n) => {
        projectId.value = n;
      }
    );
    watch(
      () => pName.value,
      async (n) => {
        await initData(n);
        if (!n) {
          projectId.value = undefined;
        }
      }
    );

    const handleChange = (e) => {
      // console.log("e", e);
      projectId.value = e;
      let t = projectList.value.find((o) => o.id == e);
      if (t) {
        emit("update:projectName", t.name);
      }else{
        emit("update:projectName","");

      }
      // emit("changeProject", projectId.value);
    };
    const { run: selectProjectListService } = ProjectService.useProjectPageApi();
    const initData = async (e = "") => {
      if (e && e.length > 0) {
        projectName.value = e;
      }
      const res = await selectProjectListService({
        projectName: projectName.value,
        statusList: "yzb,dsg,sgz,dtb,tbz,dlx,yjg",
        size: 999999999, //YF-118758
        current: 1,
      });
      if (res && res.respCode === "0000") {
        projectList.value = res.data?.records ?? [];
      }
    };
    onMounted(async () => {
      initData();
    });
    const jumpFn = () => {
      // console.log(props.jump,'jump',projectId.value)
      if (props.jump) {
        if (projectId.value && projectId.value.length > 0) {
          router.push(`/data-board/project-board/panel-item/${projectId.value}`);
        }
      }else{
        if (projectId.value && projectId.value.length > 0) {
          emit("changeProject", projectId.value);
        }else{
          emit("changeProject", "");

        }
      }
    };
    return {
      projectName,
      projectList,
      fetching,
      initData,
      projectId,
      jumpFn,
      handleChange,
    };
  },
});
